import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Icon, Message, Segment, Header } from 'semantic-ui-react';
import Highlighter from 'react-highlight-words';

const formStyle = { marginTop: '15px' };

class ResultadosCorpus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: null
    };
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  getRegExp = ejemplo => {
    if (this.props.radioValue === 'formasCombinadas') {
      return this.newRegExp(this.props.data.value);
    }
    return this.newRegExp(ejemplo.fraseActual.highlight);
  };

  newRegExp = texto =>
    new RegExp(
      `\\b${texto}(?=([\\s.\\-\\>\\"\\”\\»\\:\\;\\]\\/\\%\\)\\,\\!\\?\\®]|$))`,
      'g'
    );

  render() {
    const { activeIndex } = this.state;
    const { ejemplos, sinResultados, value } = this.props.data;
    return (
      <div style={formStyle}>
        {sinResultados ? (
          <div>
            <Header as="h3" block attached="top">
              No se encuentran resultados
            </Header>
            <Segment attached>
              No se han encontrado resultados para &quot;<b>{value}</b>&quot;
            </Segment>
          </div>
        ) : null}
        {ejemplos.length ? (
          <Accordion fluid>
            {ejemplos.map((ejemplo, index) => (
              <div key={ejemplo.fraseActual.id}>
                <Accordion.Title
                  active={activeIndex === index}
                  index={index}
                  onClick={this.handleClick}
                >
                  <Icon name="dropdown" />
                  <Highlighter
                    highlightClassName="resaltado-texto"
                    highlightStyle={{ backgroundColor: 'white' }}
                    searchWords={[this.getRegExp(ejemplo)]}
                    autoEscape={false}
                    textToHighlight={ejemplo.fraseActual.texto}
                  />
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index}>
                  <Message>
                    {ejemplo.fraseAnterior ? ejemplo.fraseAnterior.texto : null}
                    &nbsp;
                    <Highlighter
                      highlightClassName="resaltado-texto"
                      highlightStyle={{ backgroundColor: '#f8f8f9' }}
                      searchWords={[this.getRegExp(ejemplo)]}
                      autoEscape={false}
                      textToHighlight={ejemplo.fraseActual.texto}
                    />
                    &nbsp;
                    {ejemplo.fraseSiguiente
                      ? ejemplo.fraseSiguiente.texto
                      : null}
                  </Message>
                </Accordion.Content>
              </div>
            ))}
          </Accordion>
        ) : null}
      </div>
    );
  }
}

ResultadosCorpus.propTypes = {
  data: PropTypes.shape({
    ejemplos: PropTypes.arrayOf(
      PropTypes.shape({
        fraseActual: PropTypes.shape({
          highlight: PropTypes.string.isRequired,
          id: PropTypes.number.isRequired,
          texto: PropTypes.string.isRequired
        }).isRequired,
        fraseAnterior: PropTypes.shape({
          id: PropTypes.number.isRequired,
          texto: PropTypes.string.isRequired
        }).isRequired,
        fraseSiguiente: PropTypes.shape({
          id: PropTypes.number.isRequired,
          texto: PropTypes.string.isRequired
        }).isRequired
      }).isRequired
    ).isRequired,
    sinResultados: PropTypes.bool,
    value: PropTypes.string.isRequired
  }).isRequired,
  radioValue: PropTypes.string.isRequired
};

export default ResultadosCorpus;
